'use client';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import StatusBar from 'src/components/primitives/StatusBar/StatusBar';

const MaintenanceModeBar = () => {
	const maintenanceModeEstimateTs = useDriftStore(
		(s) => s.driftStatus.historyServerStatus.maintenanceModeEstimateTs
	);
	const maintenanceMode = useDriftStore(
		(s) => s.driftStatus.historyServerStatus.maintenanceMode
	);

	if (!maintenanceMode) {
		return null;
	}

	const estimatedCompletionText = maintenanceModeEstimateTs
		? ` Estimated completion: ${new Date(
				maintenanceModeEstimateTs * 1000
			).toLocaleString()}.`
		: '';

	return (
		<StatusBar variant="warning">
			Drift&apos;s history server is undergoing scheduled maintenance. Account,
			Trade, and Market History may be unavailable or inconsistent during this
			period. {estimatedCompletionText}
		</StatusBar>
	);
};

export default MaintenanceModeBar;
